import { useCallback, useEffect, useState } from "react"
import { TabPanel } from "components/navigation/TabPanel"
import PaperBox from "components/PaperBox"
import BasicInfo from "shared/vehicle/BasicInfo"
import TechnicalData from "shared/vehicle/TechnicalData"
import CustomFields from "shared/vehicle/CustomFields/CustomFields"
import { VehicleDocuments } from "shared/vehicle/components/VehicleDocuments"
import { VehicleExpenses } from "shared/vehicle/components/VehicleExpenses"
import IssueReportsCard from "shared/vehicle/IssueReportsCard"
import UpcomingServicesTab from "pages/vehicleregistry/pages/checks/UpcomingChecksTab/UpcomingChecksTab"
import { useApi } from "auth/useApi3"
import { apiEndpoints } from "generated/apiEndpoints"
import ServiceHistoryTable from "pages/vehicleregistry/pages/checks/CheckHistoryTab/CheckHistoryTable"


const tabValueIndex ={ 
    BasicInfo: 0,
    TehcnicalData: 1,
    CustomFields: 2,
    UpcomingServices: 3,
    VehicleDocuments:4,
    VehicleExpenses: 5,
    IssueReports: 6
}

const DetailsTabPanel = ({ 
    tabValue, 
    detailsResult, 
    match, 
    assemblyData, 
    isIssueReports, 
    viewList,
    viewOption,
    view,
    setView,
    customFieldsResult,
    getCustomFields
    }) => {
    
    const [tabHistory, setTabHistory] = useState([])
    const [data, issueReportApi] = useApi()
    const [iotResult, iotApi] = useApi()
    const [expensesResult, expensesApi] = useApi()
    const [attachmentResult, attachmentApi] = useApi()
    

    const fetchIssueReports = () => {
        const url = apiEndpoints.issuereports.getissuereportsbyvehicleid.replace("{vehicleid}", match.params.id)
            issueReportApi.get(url)
    } 

    const fetchIotData = (vehicleId) => {
        iotApi.get(apiEndpoints.vehicleregistry.getiotdetailsbyvehicleid.replace("{id}", vehicleId.toString()))
    }
    

    const fetchExpenses = (vehicleId) => {
        expensesApi.get(
            apiEndpoints.vehicleexpense.getvehicleexpensesbyvehicleid.replace(
            "{vehicleId}",
            vehicleId.toString()
            )
        )
    }

    const fetchDocuments = (id) => {
        const url = apiEndpoints.vehicleregistry.getvehicleattachmentsbyvehicleid.replace("{vehicleId}", id)
            attachmentApi.get(url)
    }


  const tabComponent = (tabValue) => {
    switch (tabValue) {
      case 0:
        return <BasicInfo 
                tabValue={tabValue} 
                fetchIotData={fetchIotData} 
                iotResult={iotResult} 
                tabValueIndex={tabValueIndex} 
                tabHistory={tabHistory} 
                setTabHistory={setTabHistory} 
                data={detailsResult.data} 
                vehicleId={match.params.id}
                />
      case 1:
        return <TechnicalData 
                data={detailsResult.data} 
                assemblyData={assemblyData}
                />
      case 2:
        return <CustomFields 
                vehicleId={detailsResult.data.id} 
                data={customFieldsResult.data} 
                customFieldsResult={customFieldsResult}
                tabValueIndex={tabValueIndex}
                setTabHistory={setTabHistory} 
                tabHistory={tabHistory} 
                tabValue={tabValue}
                getCustomFields={getCustomFields}
                vehicleData={detailsResult.data}
                />
      case 3:
        if (view === viewOption.Upcoming) {
                return <UpcomingServicesTab 
                params={match.params}
                viewList={viewList}
                view={view}
                setView={setView}
                />
            } else {

                return <ServiceHistoryTable
                params={match.params}
                viewList={viewList}
                view={view}
                setView={setView}
                />
            }
      case 4:
        return <VehicleDocuments 
                data={detailsResult.data} 
                tabValueIndex={tabValueIndex} 
                fetchDocuments={fetchDocuments}
                attachmentResult={attachmentResult}
                tabHistory={tabHistory}
                setTabHistory={setTabHistory}
                tabValue={tabValue}
                vehicleId={match.params.id}
                
                />
      case 5:
        return <VehicleExpenses 
                setTabHistory={setTabHistory} 
                tabHistory={tabHistory} 
                tabValue={tabValue} 
                vehicleData={detailsResult.data} 
                tabValueIndex={tabValueIndex} 
                expensesResult={expensesResult} 
                fetchExpenses={fetchExpenses}
                />
      case 6:
        return isIssueReports && <IssueReportsCard 
                match={match} 
                data={data} 
                tabHistory={tabHistory} 
                setTabHistory={setTabHistory} 
                tabValue={tabValue} 
                isIssueReports={isIssueReports} 
                fetchIssueReports={fetchIssueReports} 
                vehicleId={detailsResult?.data?.id} 
                tabValueIndex={tabValueIndex}
                />
      default:
        return null
    }
  }

  return (
        <TabPanel value={tabValue} index={tabValue}>
          <PaperBox mt={0}>
           {tabComponent(tabValue)}     
          </PaperBox>
        </TabPanel>
    )
}

export default DetailsTabPanel